export default __webpack_public_path__ + "static/media/corona-virus.8de031e2.jpg";